<template>
  <div class="card content-crud">
    <div class="ibox" v-if="!$route.params.operation">
      <div class="ibox-title" style="padding: 16px">
        <h3>
          {{ crudName }}
          <router-link
            :to="endPoint + '/add'"
            class="btn btn-primary"
            v-show="enableAdd"
            style="float: right; margin-top: -5px"
            >{{ newText }}</router-link
          >
        </h3>
      </div>
      <div class="ibox-content">
        <div class="block m-b-md text-right" v-if="enableAddModal">
          <button type="button" class="btn btn-success" @click="addModal">
            {{ $t('common.crud.add') }} {{ crudName }}
          </button>
        </div>

        <v-server-table
          style="padding: 10px"
          ref="table"
          :tableData="tableData"
          :name="table"
          :url="url"
          :columns="columns"
          :options="options"
        >
          <div
            :slot="'filter__' + filter.name"
            v-for="filter in customFilters"
            :key="filter.name"
          >
            <template v-if="filter.type == 'calendar'">
              <input
                type="date"
                class="form-control"
                :name="filter.call"
                :id="filter.name"
                @change="filterChange(filter.call, filter.name)"
              />
            </template>
          </div>

          <div slot="actions" slot-scope="props" style="width: 100px">
            <a
              v-show="enableDownload"
              data-toggle="tooltip"
              :title="$t('common.crud.download')"
              class="btn btn-info fa fa-download"
              @click="download(props.row.file)"
            ></a>
            <button
              v-show="enableView"
              data-toggle="tooltip"
              :title="$t('common.crud.consult')"
              class="btn btn-crud view"
              @click="view(props.row.id)"
            >
              <i
                class="fas fa-eye"
                data-toggle="tooltip"
                :title="$t('common.crud.view')"
              ></i>
            </button>
            <button
              v-show="enableEdit"
              data-toggle="tooltip"
              :title="$t('common.crud.edit')"
              type="button"
              class="btn btn-crud edit"
              @click="edit(props.row.id)"
            >
              <i
                class="fas fa-pencil-alt"
                data-toggle="tooltip"
                :title="$t('common.crud.edit')"
              ></i>
            </button>
            <a
              v-show="enableEditModal"
              @click="editModal(props.row.id)"
              data-toggle="tooltip"
              :title="$t('common.crud.edit')"
              class="btn btn-warning fa fa-pencil"
            ></a>
            <button
              v-show="enableDelete"
              data-toggle="tooltip"
              :title="$t('common.crud.delete')"
              type="button"
              class="btn btn-crud delete"
              @click="destroy(props, props.row, props.index)"
            >
              <i
                class="far fa-trash-alt"
                data-toggle="tooltip"
                :title="$t('common.crud.remove')"
              ></i>
            </button>
            <button
              v-show="enableReset"
              data-toggle="tooltip"
              :title="$t('common.crud.resetPassword')"
              class="btn btn-crud view key"
              @click="resetpassword(props.row.id)"
            >
              <i
                class="fas fa-key"
                data-toggle="tooltip"
                :title="$t('common.crud.resetPasswordIcon')"
              ></i>
            </button>
            <template v-for="extra in extra">
              <button
                data-toggle="tooltip"
                :title="extra.title"
                :key="extra.id"
                :class="extra.class"
                @click="callExtra(extra.name, props, props.row, props.index)"
              >
                <i :class="extra.icon" v-if="extra.icon.length > 0"></i>
                {{ extra.label }}
              </button>
            </template>
          </div>
          <div slot="photo" slot-scope="props">
            <img :src="props.row.photo" alt class="photo" />
          </div>
          <div slot="cover_photo" slot-scope="props">
            <img :src="props.row.cover_photo" alt class="photo" />
          </div>
          <div slot="color" slot-scope="props">
            <div
              class="box"
              v-bind:style="{ 'background-color': props.row.color }"
            ></div>
            <span class="bold">{{ props.row.color }}</span>
          </div>
          <div slot="qrcode" slot-scope="props">
            <img :src="props.row.qrcode + ''" alt class="qrcode" />
            <br />
            <span class="bold">{{ props.row.qrcode_name }}</span>
          </div>
          <div slot="qrcodeid" slot-scope="props">
            <qrcode-vue
              class="code_crud"
              size="70"
              :value="
                props.row.qrcodeid ? props.row.qrcodeid + '' : props.row.id + ''
              "
              level="H"
            ></qrcode-vue>
          </div>
        </v-server-table>
      </div>
    </div>
  </div>
</template>

<script>
import { Pagination } from "vue-pagination-2";
// import BaseForm from "./BaseForm";
// import QrcodeVue from "qrcode.vue";

export default {
  data: function () {
    return {
      records: [],
      pages: [],
      tableData: [],
      model: [],
    };
  },
  props: {
    crudName: String,
    fieldStatus: String,
    status: String,
    newText: String,
    table: String,
    customFilters: Array,
    columns: Array,
    options: Object,
    endPoint: String,
    with: String,
    enableAdd: Boolean,
    enableAddModal: Boolean,
    enableEditModal: Boolean,
    enableEdit: Boolean,
    enableDelete: Boolean,
    enableView: Boolean,
    enableReset: Boolean,
    enableDownload: Boolean,
    extra: Array,
    dataForm: Object,
  },
  mounted() {
    this.enableAddModal = this.enableAddModal || false;
    this.enableEditModal = this.enableEditModal || false;
  },
  computed: {
    url() {
      return (
        this.$store.getters.api + this.endPoint + (this.with ? this.with : "")
      );
    },
  },
  methods: {
    filterChange(call, date) {
      let valor = $("#" + date).val();
      valor = valor.replace("T", " ");

      console.log(call);

      this.$emit(call, valor);
      this.$refs.table.refresh();
    },
    callExtra(name, props, row, index) {
      this.$emit(name, {
        props,
        row,
        index,
      });
    },
    edit(id) {
      this.$router.push({
        path: this.endPoint + "/edit/" + id,
      });
    },
    resetpassword(id) {
      this.$router.push({
        path: this.endPoint + "/resetpassword/" + id,
      });
    },
    view(id) {
      this.$router.push({
        path: this.endPoint + "/view/" + id,
      });
    },
    download(file) {
      window.open(file, "_blank");
    },
    destroy(props, row, index) {
      const self = this;

      swal({
        title: self.$t("common.crud.deleteTitle"),
        text: self.$t("common.crud.deleteText"),
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: self.$t("common.crud.deleteConfirm"),
        showLoaderOnConfirm: true,
        buttons: {
          catch: {
            text: self.$t("common.crud.no"),
            value: "cancel",
            className: "btn-danger",
          },
          confirm: {
            text: self.$t("common.crud.yes"),
            value: "confirm",
          },
        },
      }).then((value) => {
        switch (value) {
          case "cancel":
            swal(self.$t("common.crud.cancelledTitle"), self.$t("common.crud.cancelledText"), "info");
            break;

          case "confirm":
            axios
              .delete(this.url + "/" + row.id, {
                id: row.id,
              })
              .then((response) => {
                self.$refs.table.data.splice(index - 1, 1);
                swal(self.$t("common.crud.successTitle"), self.$t("common.crud.deletedText"), "success");
              })
              .catch((error) => {
                swal(
                  self.$t("common.crud.errorTitle"),
                  self.$t("common.crud.inUseText"),
                  "error"
                );
              });
            break;
        }
      });
    },
    addModal: function () {
      this.$emit("addModal");
    },
    editModal: function (id) {
      this.$emit("editModal", id);
    },
  },
  components: {
    Pagination,
  },
};
</script>

<style scoped>
.photo {
  max-height: 90px;
  max-width: 90px;
}
.key {
  border: 2px solid #ff7301;
}
</style>
